<template>
  <v-card-text class="py-0">
    <div style='display: flex;'>
      <postItemForm
        v-model="regulationItem.rules.permitItems"
        label='許可アイテム'
        :exceptItems="['heading2', 'heading3']"
      ></postItemForm>
    </div>
  </v-card-text>
</template>

<script>
import postItemForm from './forms/postItemForm'

export default {
  name: 'ItemAfterHeading3',
  components: {
    postItemForm
  },
  props: {
    regulationItem: {
      type: Object,
      required: true
    }
  },
  mounted: function () {
    if (!this.regulationItem.rules.permitItems) {
      this.regulationItem.rules = { permitItems: [] }
    }
  }
}
</script>
